import React, { useState } from 'react';

import Toggle from '@r1-frontend/ui-react/components/controls/Toggle';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import { DecoderList } from '~/src/features/full-buy/containers/DecoderList';
import { EquipmentList } from '~/src/features/full-buy/containers/EquipmentList';

type TAdditionalEquipmentWithToggleProps = {
    routerCategory?: EShopCategory.Routers | EShopCategory.PrivateSectorEquipment,
    [key: string]: unknown,
}

const TOGGLE_MODES = {
    leftText: 'Wi-Fi-роутеры',
    rightText: 'ТВ-приставки',
};

export const AdditionalEquipmentWithToggle = ({ routerCategory = EShopCategory.Routers }: TAdditionalEquipmentWithToggleProps) => {
    const [toggleState, setToggleState] = useState(TOGGLE_MODES.leftText);

    return <>
            <Toggle
                textsValues={TOGGLE_MODES}
                onChangeCallback={setToggleState}
                activeTab={toggleState}
                colorTab={COLORS.ButtonPrimary}
                fontSize={FONTS.MediumXS}
                isDifferentColorText={true}
            />

            {toggleState === TOGGLE_MODES.leftText
                ? <EquipmentList withCarousel={true} category={routerCategory}/>
                : <DecoderList withCarousel={true}/>
            }
    </>;
};
